export default __webpack_public_path__ + "static/media/v1.9ebc3999.png";